module.exports = __webpack_public_path__ + "static/media/spinner.a45e62da.gif";